import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { GoogleSignInButton } from "./Login";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "", full_name: "", role: "candidate", phone: "", company_name: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await register(f);
      toast.success(`Welcome, ${u.full_name}!`);
      nav(u.role === "employer" ? "/employer" : "/candidate");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-5rem)] flex items-center justify-center bg-[#F8FAFC] py-16" data-testid="register-page">
      <div className="w-full max-w-md ae-card p-8">
        <div className="ae-overline mb-2">Get Started</div>
        <h1 className="font-heading text-3xl font-medium text-[#0F2A4A] mb-6">Create account</h1>

        <GoogleSignInButton label="Sign up with Google" />

        <div className="relative my-6">
          <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-slate-200"></div></div>
          <div className="relative flex justify-center text-xs"><span className="bg-white px-3 text-slate-500 uppercase tracking-wider">or with email</span></div>
        </div>

        <div className="flex gap-2 mb-5">
          {[
            { v: "candidate", l: "Job Seeker" },
          ].map(o => (
            <button key={o.v} onClick={() => setF({ ...f, role: o.v })} data-testid={`role-${o.v}`}
              className={`flex-1 py-2 rounded-xl text-sm font-medium border-2 transition-all ${f.role === o.v ? "border-[#C5A059] bg-[#C5A059]/5 text-[#0F2A4A]" : "border-slate-200 text-slate-500 hover:border-slate-300"}`}>
              {o.l}
            </button>
          ))}
        </div>

        <form onSubmit={submit} className="space-y-4">
          <input required placeholder="Full Name" value={f.full_name} onChange={e => setF({ ...f, full_name: e.target.value })}
            data-testid="reg-name" className="w-full rounded-xl border border-slate-200 bg-slate-50 outline-none focus:bg-white focus:border-[#C5A059] px-4 py-3 text-sm" />
          <input required type="email" placeholder="Email" value={f.email} onChange={e => setF({ ...f, email: e.target.value })}
            data-testid="reg-email" className="w-full rounded-xl border border-slate-200 bg-slate-50 outline-none focus:bg-white focus:border-[#C5A059] px-4 py-3 text-sm" />
          <input placeholder="Phone" value={f.phone} onChange={e => setF({ ...f, phone: e.target.value })}
            data-testid="reg-phone" className="w-full rounded-xl border border-slate-200 bg-slate-50 outline-none focus:bg-white focus:border-[#C5A059] px-4 py-3 text-sm" />
          {f.role === "employer" ? (
            <div className="rounded-xl bg-amber-50 border border-amber-200 p-4 text-sm text-amber-900">
              <b>Looking to hire?</b> Employers don't create accounts — please <Link to="/for-employers" className="text-[#C5A059] font-medium underline">submit a hiring requirement</Link> and our team will reach out.
            </div>
          ) : null}
          <input required type="password" placeholder="Password (min 6 chars)" minLength={6} value={f.password} onChange={e => setF({ ...f, password: e.target.value })}
            data-testid="reg-password" className="w-full rounded-xl border border-slate-200 bg-slate-50 outline-none focus:bg-white focus:border-[#C5A059] px-4 py-3 text-sm" />
          <button disabled={loading} className="ae-btn-primary w-full" data-testid="reg-submit">
            {loading ? "Creating…" : "Create Account"}
          </button>
        </form>
        <div className="mt-6 text-center text-sm text-slate-600">
          Already have an account? <Link to="/login" className="text-[#C5A059] font-medium">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
